<template>
  <span class="vsm-status-row-actions">
    <vsm-history-link-button />&nbsp;
    <vsm-reload-button @click="$emit('reload')" />
  </span>
</template>

<script>
import VsmHistoryLinkButton from './VsmHistoryLinkButton.vue'
import VsmReloadButton from './VsmReloadButton.vue'

export default {
  name: 'VsmStatusRowActions',
  components: {
    VsmHistoryLinkButton,
    VsmReloadButton,
  },
}
</script>
